import actions from './configActions';
import reducer from './configReducer';
import selectors from './configSelectors';

export default {
  actions,
  reducer,
  selectors,
};
